import httpClient from "Api/httpClient";

const END_POINT = "/data_import_logs";

const getDataImportLogs = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getDataImportLog = (import_id) => {
    if (!import_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + import_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printDataImportLog = (import_id) => {
    if (!import_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?import_id=" + import_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createDataImportLogs = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateDataImportLogs = (payload, import_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + import_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteDataImportLogs = (import_id) => {
    const DELETE_END_POINT = END_POINT + "/" + import_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const getDataImportTableFields = (table_id) => {
    const GET_FIELDS_END_POINT = "/sql/tables/" + table_id + "/fields_with_raltionships";
    return httpClient.get(GET_FIELDS_END_POINT, { retryTimes: 3 });
};

const importDataLog = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const IMPORT_END_POINT = "/data_import_log";
    return httpClient.post(IMPORT_END_POINT, body);
};
export {
    getDataImportLogs,
    getDataImportLog,
    printDataImportLog,
    createDataImportLogs,
    updateDataImportLogs,
    deleteDataImportLogs,
    getDataImportTableFields,
    importDataLog,
};
